<ng-container *ngIf="modalabierto">

  <div class="backdrop"></div>

  <div class="modalPanel animated {{animacion}}">

    <div class="modalTitulo">
      <span>{{'Login.RecuperarPasswordTitulo' | translate}}</span>
    </div>

    <div class="divisor16"></div>
    <div class="divisorgris"></div>
    <div class="divisor16"></div>

    <!-- Mensaje -->
    <div class="mensajeRecuperar">
      {{'Login.MensajeRecuperarPassword' | translate}}
    </div>

    <div class="divisor32"></div>

    <!-- Cuenta -->
    <div class="col-12" style="padding: 0px">

      <div class="floatLabel registro">
        <input placeholder="" type="text" id="emailrecuperar" class="form-control" [(ngModel)]="cuenta" name="emailrecuperar"
               #emailrecuperar="ngModel" required [ngClass]="{'is-filled':emailrecuperar.value }" >

        <label class="faeLabelInput">{{'Login.Cuenta' | translate}}</label>

        <button *ngIf="emailrecuperar.value" class="btnTimes" (click)="correo = '';" onclick="Focus('emailrecuperar')">
          <span class="fa fa-times"></span>
        </button>

        <span class="textoError" [hidden]="emailrecuperar.valid || (!emailrecuperar.touched && !errorActivo)">
              {{'Login.ErrorCuenta' | translate}}
        </span>

      </div>

    </div>

    <!-- Botones -->
    <div class="divisor24"></div>

    <div class="col-12 text-center">
      <button id="botonCambiarPassword" class="btn boton filled redondeado botonSM botonRecuperar" (click)="EnviarPasssword()">
        {{'Login.RecuperarPasswordBoton' | translate}}
      </button>
    </div>

    <div class="col-12 text-center">
      <button id="botonCancelar" class="btn boton redondeado botonSM botonRecuperar" (click)="Cerrar()">
        {{'Cancelar' | translate}}
      </button>
    </div>

  </div>

</ng-container>
